import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient, HttpXhrBackend } from "@angular/common/http";
import { catchError, map, shareReplay } from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class VersionProvider {
	public version$: Observable<string>;
	private _client = new HttpClient(new HttpXhrBackend({build: () => new XMLHttpRequest()}));

	constructor() {
		this.version$ = this._client.get<{ version: string }>('/assets/version.json').pipe(
			map(response => response.version),
			catchError(error => {
				console.error('Error fetching version.json:', error);
				return of('unknown');
			}),
			shareReplay(1)
		);
	}
}
